export function computeIdealScrollTopForElement(
  container: Element,
  element: Element,
): number {
  const fraction = computeIdealScrollFractionForElement(container, element);

  return convertScrollFractionToScrollTop(container, fraction);
}

// TODO: This can probably be simplified significantly.
function computeIdealScrollFractionForElement(
  container: Element,
  element: Element,
) {
  const scrollTop = container.scrollTop;
  const scrollHeight = container.scrollHeight;
  const clientHeight = container.clientHeight;

  if (scrollHeight <= clientHeight) {
    return 0;
  }

  const containerRect = container.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();

  const elementTopInScrollRect =
    elementRect.top - containerRect.top + scrollTop;
  const elementBottomInScrollRect =
    elementRect.bottom - containerRect.top + scrollTop;

  const elementTopInScrollFraction = elementTopInScrollRect / scrollHeight;
  const elementBottomInScrollFraction =
    elementBottomInScrollRect / scrollHeight;

  const elementAverageScrollFraction =
    (elementTopInScrollFraction + elementBottomInScrollFraction) / 2;

  const elementMiddleInScrollFraction =
    elementTopInScrollFraction * (1 - elementAverageScrollFraction) +
    elementBottomInScrollFraction * elementAverageScrollFraction;

  return elementMiddleInScrollFraction;
}

function convertScrollFractionToScrollTop(
  container: Element,
  fraction: number,
): number {
  const scrollHeight = container.scrollHeight;
  const clientHeight = container.clientHeight;
  const maxScrollTop = Math.max(0, scrollHeight - clientHeight);

  return Math.max(0, Math.min(maxScrollTop * fraction, maxScrollTop));
}
